import { useParams } from 'react-router-dom'
import { ModalComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import useCountryState from '../../../../../../../../utils/hooks/useCountry'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { ShippingZoneModelType } from '@teinor/erp/types/company/config/shipping/shippingZoneGroup/shippingZone'
import { getDictionaryCountries } from '../../../../../../../../utils/reducers/getters'
import {  getDictionaryStates } from  '../../../../../../../../utils/globals/countries'
import { LittleModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { useCallback } from 'react'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { changeErrorMessage } from '../../../../../../../../utils/reducers/reduxDispatch'
import { sortCountries } from '../../../../../../../../utils/globals/sortCountries'


interface ModalCreateConfigShippingZoneProps extends ModalComponentProps { }

const ModalCreateConfigShippingZone: React.FC<ModalCreateConfigShippingZoneProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const { country, setCountry } = useCountryState({})
    const { ShippingZoneGroupId } = useParams()
    const { handleOnError } = useModalCreateConfigShippingZoneLogic()
    const fields: FormRender<ShippingZoneModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'country',
                    label: t('country', 'País'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    required: true,
                    value: country,
                    onChange: (value: string) => setCountry(value)
                },
                {
                    name: 'state',
                    label: t('state', 'Provincia'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: getDictionaryStates(country),
                    required: false,
                },
                {
                    name: 'postal_code',
                    label: t('postalCode', 'Código Postal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: false
                },
                {
                    name: 'ShippingZoneGroupId',
                    component: 'InputHidden',
                    value: ShippingZoneGroupId
                }
            ]
        },
    ]
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/shipping/shippingZone/createShippingZone'} onChangeError={handleOnError} translations={{
        title: t('createNewShippingZone', 'Crear nueva zona de envío'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)

}

const useModalCreateConfigShippingZoneLogic = () => {
    const { t } = useTwinTranslation()
    const error = t('errorCombinationShippingZone', 'La combinación introducida ya existe en una zona de envío')

    const handleOnError: OnSubmit = useCallback(async (res: Response) => {
        const responseJSON = await res.json()
        if (responseJSON.errors[0].msg === 'The country, province or/and postal code already exists') {
            changeErrorMessage(error)
        } else {
            changeErrorMessage(responseJSON.errors[0].msg)
        }
        }, [error])
    return { handleOnError }
}


export default ModalCreateConfigShippingZone